// extracted by mini-css-extract-plugin
export default {"NameContainer":"_NameContainer--sf3zK","Link":"_Link--E0DIN","Name":"_Name--1NfjR"};